export const THEME_ACTION = '/action/set-theme'
